var AppDispatcher = require('../dispatcher/app-dispatcher');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var Constants = require('../constants/global');

EventEmitter.prototype._maxListeners = 100;

var _currentUser = {}; 

const CHANGE_EVENT = 'change';

var loginRequired = function() {
  _currentUser = assign({}, { loginRequired: true} );
};

var UserStore = assign({}, EventEmitter.prototype, {

  getCurrent: function() {
    return _currentUser;
  },

  isLoggedIn: function(id) {
    return _currentUser.loggedIn;
  },

  isLoginRequired: function(id) {
    return _currentUser.loginRequired;
  },
  
  addChangeListener: function(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener: function(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange: function() {
    this.emit(CHANGE_EVENT);
  },

  dispatcherIndex: AppDispatcher.register(function(payload){
    var action = payload.action;

    switch(action.actionType) {

    case Constants.LOGIN_REQUIRED:
      UserStore.emitChange();
      break;
      
    default:
      return true;
    }
  })  
});

module.exports = UserStore;



// WEBPACK FOOTER //
// ./stores/user-store.js